const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  gridList: {
    width: 800,
    height: 750
  },
  button: {
    backgroundColor: '#FFF',
    marginRight: 20
  },
  backButton: {
    backgroundColor: '#A5668B',
    marginRight: 20
  },
  headerText: {
    textAlign: 'center',
    marginTop: '10%',
    marginBottom: '10%'
  },
  hrContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }
}

export default styles
